import React from 'react';

import { withRouter } from 'react-router-dom';
import AccountService from '../../../Service/AccountService';

import { Button } from 'antd';
import TopUpDetails from './TopUpDetails';

import Table from '../../Common/Table';
import { convertToPhilippinesTime } from '../../../AppUtil/AppUtil';
import { hot } from 'react-hot-loader';

class Topup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_showModal: false,
			_topupid: null
		};
	}

	setTopupSource = async queryUrl => {
		return AccountService.getRecordTopup(this.props.match.params.id, queryUrl);
	};

	handleShowModal = id => {
		this.setState({ _showModal: !this.state._showModal, _topupid: id });
	};

	render() {
		const dayjs = require('dayjs');
		const topup = [
			{
				name: 'topup_date',
				label: 'Date/Time',
				options: {
					sort: false,
					customBodyRender: value => {
						return (
							<span className="bold-important">{value ? convertToPhilippinesTime(value) : 'N/A'}</span>
						);
					}
				}
			},
			{
				name: 'channel',
				label: 'Channel',
				options: {
					sort: false,
					customBodyRender: value => {
						return value || 'LendAmi Wallet';
					}
				}
			},
			{
				name: 'total_amount',
				label: 'Amount(₱)',
				options: {
					sort: false,
					customBodyRender: value => {
						const PHP = new Intl.NumberFormat('PH', {
							style: 'currency',
							currency: 'PHP'
						});
						return <span className="bold-important">{PHP.format(Number(value.toFixed(2)))}</span>;
					}
				}
			},
			{
				name: 'id',
				label: 'Action',
				options: {
					sort: false,
					customBodyRender: value => {
						return (
							<Button onClick={() => this.handleShowModal(value)} type="link">
								Detail
							</Button>
						);
					}
				}
			}
		];

		return (
			<>
				<TopUpDetails
					cancel={() => this.setState({ _showModal: false })}
					id={this.state._topupid}
					open={this.state._showModal}
				/>

				<Table
					columns={topup}
					dataSourceHandler={this.setTopupSource}
					dataSourceName="wallet"
					title="Wallet Top-ups"
				/>
			</>
		);
	}
}

export default withRouter(hot(module)(Topup));
